import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './base.module.css';
import { Header, Footer } from './components';
const BaseLayout: React.FC = () => {
  return (
    <div className={styles.base}>
      <Header isFixed={true} />
      <Outlet />
      <Footer />
    </div>
  );
};

export default BaseLayout;
